import db from '../index';
import { ServiceData } from '../service';
import { entityServiceFactory } from '../entityServiceFactory';

export interface IssuesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<IssuesServiceData>(db, 'issuesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
